import SurveyModal from '@features/infos-modal/infos-modal';
export default SurveyModal;
